'use client'

import Link from 'next/link'
import React, { useEffect, useRef } from 'react'

interface Props {
    video: string
    autoplay?: boolean
    url?: string
}

const BannerVideo = ({ video, autoplay = false, url }: Props) => {
    const videoRef = useRef<HTMLVideoElement>(null)

    useEffect(() => {
        const videoElement = videoRef.current
        if (!videoElement || !autoplay) return
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        videoElement.play()
                    } else {
                        videoElement.pause()
                    }
                })
            },
            {
                threshold: 0.5,
            }
        )

        observer.observe(videoElement)

        return () => {
            observer.disconnect()
        }
    }, [autoplay])

    return (
        <Link href={url || '#'}>
            <div className='h-56 overflow-hidden rounded-lg sm:h-72'>
                <video
                    ref={videoRef}
                    src={video}
                    preload='metadata'
                    loop
                    muted
                    playsInline
                    className='h-full w-full object-cover'
                />
            </div>
        </Link>
    )
}

export default BannerVideo
